export const environment = {
  production: false,
  apiUrl: `${window.location.origin}/api`,
  syncKey: 'TvygaKQPg6rKHdGiU3uF',
  branding: {
    appTitle: 'Bamboosoft',
    logoLight: 'assets/img/logo/bamboosoftLogo.png',
    logoDark: 'assets/img/logo/bamboosoftLogo.png',
    faviconPath: 'assets/img/logo/bamboosoftLogo.png'
  },
  auth: {
    domain: 'crc.ca.auth0.com',
    clientId: 'WcvatfBX1xkwAg4cAiLi3i3MsTi24lJw',
    audience: 'https://crc.api',
    redirectUri: `${window.location.origin}`,
    roleClaimType: 'crc/roles'
  }
};
